import { useCart } from "../Context/CartContext";
import { useNavigate } from "react-router-dom";
import "./Cart.css";
import BASE_URL from "../config";

function Cart() {

  const { cartItems, removeFromCart } = useCart();
  const navigate = useNavigate();

  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <section className="cart-section">
      <div className="container">

        <h1 className="cart-title">Shopping Cart</h1>

        {cartItems.length === 0 ? (
          <div className="empty-cart">
            <h3>Your cart is empty</h3>
            <p>Add your favourite fragrances to continue shopping.</p>
          </div>
        ) : (
          <>
            <div className="cart-items">

              {cartItems.map((item) => (
                <div className="cart-card" key={item.id}>

                  <div className="cart-image">
                    <img
                      src={`https://sahscents.xpertoneevents.com/uploads/${item.image}`}
                      alt={item.name}
                    />
                  </div>

                  <div className="cart-info">
                    <h3>{item.name}</h3>

                    <p>{item.description}</p>

                    <span>Quantity : {item.quantity}</span>
                  </div>

                  <div className="cart-price">
                    <h3>AED {item.price}</h3>

                    <button
                      onClick={() => removeFromCart(item.id)}
                    >
                      Remove
                    </button>
                  </div>

                </div>
              ))}

            </div>

            <div className="cart-summary">

              <h2>Order Summary</h2>

              <div className="summary-row">
                <span>Total</span>
                <strong>AED {total}</strong>
              </div>

             <button
  className="checkout-btn"
  onClick={() => navigate("/checkout")}
>
  Proceed To Checkout
</button>

            </div>
          </>
        )}

      </div>
    </section>
  );
}

export default Cart;